window.hoculus = window.hoculus || {};
if (console && console.log) {
  console.log(
    `Coded by %cHoculus srl %con %cShopify %c- %c${Shopify.theme.name} %c -> https://www.hoculus.com`,
    "color: red; font-weight: bold",
    "color: unset",
    "color: green",
    "color: unset",
    "color: blue",
    "color: unset; font-weight: bold"
  );
}
var arr = [],
  customObj = {};
window.hoculus = window.hoculus || {};
hoculus.configurator = window.hoculus.configurator || {};
hoculus.utils = class {
  getScript(source, callback) {
    hoculus.loadedScripts = hoculus.loadedScripts || [];
    if (hoculus.loadedScripts.includes(source)) {
      setTimeout(callback, 0);
    } else {
      var script = document.createElement("script");
      var prior = document.getElementsByTagName("script")[0];
      script.defer = 1;

      script.onload = script.onreadystatechange = function (_, isAbort) {
        if (
          isAbort ||
          !script.readyState ||
          /loaded|complete/.test(script.readyState)
        ) {
          script.onload = script.onreadystatechange = null;
          script = undefined;

          if (!isAbort && callback) setTimeout(callback, 0);
        }
      };
      script.src = source;
      prior.parentNode.insertBefore(script, prior);
    }
  }
  async getScriptAsync(source) {
    hoculus.loadedScripts = hoculus.loadedScripts || [];
    return await new Promise(function (resolve, reject) {
      if (hoculus.loadedScripts.includes(source)) {
        resolve(true);
      } else {
        var script = document.createElement("script");
        var prior = document.getElementsByTagName("script")[0];
        script.defer = 1;

        script.onload = script.onreadystatechange = function (_, isAbort) {
          if (
            isAbort ||
            !script.readyState ||
            /loaded|complete/.test(script.readyState)
          ) {
            script.onload = script.onreadystatechange = null;
            script = undefined;

            if (!isAbort) setTimeout(resolve(true), 0);
          }
        };

        script.src = source;
        prior.parentNode.insertBefore(script, prior);
      }
    });
  }
  insertScriptTag(html) {
    let script = document.createElement("script");
    let head = document.getElementsByTagName("head")[0];
    script.innerHTML = html;
    head.appendChild(script);
  }
  insertCss(css) {
    let link = document.createElement("link");
    link.setAttribute("rel", "stylesheet");
    link.setAttribute("href", css);
    document.head.appendChild(link);
  }
  addDiscount(discount) {
    return new Promise(function (resolve, reject) {
      $.ajax({
        url: "/discount/" + discount,
        complete: function (data) {
          resolve(data);
        },
        error: function () {
          resolve();
        },
      });
    });
  }
  async waitFunction(wfunction) {
    let _this = this;
    this.check = function () {
      if (typeof wfunction == "function") {
        resolve(true);
      } else {
        setTimeout(_this.check(), 50);
      }
    };
    return await new Promise(function (resolve, reject) {
      _this.check();
    });
  }
  async waitElement(selector) {
    return await new Promise(function (resolve, reject) {
      var check = function () {
        if (document.querySelector(selector) !== null) {
          resolve(true);
        } else {
          setTimeout(check, 50);
        }
      };
      check();
    });
  }
  static domready(callback) {
    if (document.readyState == "complete") callback();
    else document.addEventListener("DOMContentLoaded", callback);
  }
  static async onLoad() {
    if (hoculus.settings) {
      var hs = hoculus.settings || {};
      if (hs.is_blog_page) hoculus.Blog = new hoculus.translateOrQuitBlog();
    }
    if (document.querySelector("#whatsapp-button")) {
      new hoculus.whatsappWidget();
    }
    document.querySelector(".configurator-container")
      ? hoculus.configurator.obj.init()
      : 0;
    console.log("onLoad finish");
  }
};

hoculus.translateOrQuitBlog = class {
  constructor() {
    this.selector = "[data-hoculus-available-languages]";
    this.header = document.querySelector('[data-section-id="header"]');
    this.locationLanguage = theme.routes.home.split("/")[1];
    if (this.locationLanguage.length > 0) {
      this.init();
    }
  }
  init = () => {
    document.querySelectorAll(this.selector).forEach((e) => {
      let parent = e.closest("main");
      let metaLangs = e.dataset.hoculusAvailableLanguages.split(",");
      let related_title = document.querySelectorAll(
        "header.section-header > h2.section-header__title"
      )[0];
      related_title.parentElement.nextElementSibling.innerText == "" &&
        related_title.remove();
      this.checkLanguage(parent, metaLangs);
    });
  };
  checkLanguage = (parent, languages) => {
    let check = false;
    languages.some((lang) => {
      if (this.locationLanguage === lang) {
        check = true;
        return true;
      }
    });
    if (!check) {
      parent.remove();
      hoculus.template_404 &&
        this.header.insertAdjacentHTML("beforeend", hoculus.template_404);
    }
  };
};
hoculus.whatsappWidget = class extends hoculus.utils {
  constructor() {
    super();
    super.getScript(hoculus.assets.js.jquery, this.init);
  }
  init() {
    const selector = "#whatsapp-button";
    const node = $(selector);
    const options = node.data("whatsappSettings");
    super.insertCss(hoculus.themeData.floatingWppCss);
    super.getScript(hoculus.themeData.floatingWppJs, function () {
      node.floatingWhatsApp(options);
      node.show();
    });
  }
};
var scelta = document.querySelectorAll('input[type="radio"]:checked');

hoculus.configurator.obj = {
  init: false,
  hidden: [],
  groups: [],
  formSelector: '[id^="AddToCartForm-template"]',
  multiCheckSelector: ".variant-input.hoculus-multicheck",
  sliderSelector: ".variant-wrapper.js.slider-wrapper fieldset",
  radioSelector: ".variant-input.hoculus-radio",
  subPriceSelector: ".hoculus-price-sub [data-hoculus-sub-price]",
  subDeliverySelector: ".hoculus-price-sub [data-hoculus-delivery-price]",
  dataBuyNow: "[data-hoculus-buy-now]",
  addToCart: "[data-add-to-cart]",
  loadingClass: "btn--loading",
  special_note: "[special_note]",
  init: function () {
    if (hoculus.configurator["options_split"] != undefined) {
      hoculus.configurator["options_split"].forEach((e) => {
        new hoculus.configurator.obj.optionSplit(e);
      });
    }
    document
      .querySelectorAll(hoculus.configurator.obj.multiCheckSelector)
      .forEach((e) => {
        new hoculus.configurator.obj.multiCheck(e);
      });
    hoculus.configurator.obj.multiCheck.updateAttributes();
    document
      .querySelectorAll(hoculus.configurator.obj.special_note)
      .forEach((e) => {
        new hoculus.configurator.obj.special__note(e);
      });
    document
      .querySelectorAll(hoculus.configurator.obj.sliderSelector)
      .forEach((e) => {
        new hoculus.configurator.obj.slider(e);
      });
    hoculus.configurator.obj.slider.updateAttributes();
    document
      .querySelectorAll(hoculus.configurator.obj.radioSelector)
      .forEach((e) => {
        new hoculus.configurator.obj.radio(e);
      });
    hoculus.configurator.obj.radio.updateAttributes();
    scelta.forEach((item, index) => {
      if (item != undefined && item.getAttribute("data_field") != null) {
        forGiftProduct(item);
      }
    });
    if (hoculus.configurator["options_subtitle"] != undefined) {
      hoculus.configurator["options_subtitle"].forEach((e) => {
        new hoculus.configurator.obj.optionSubtitle(e);
      });
    }
    hoculus.configurator.obj.init = true;

    hoculus.configurator.obj.buy_now(
      hoculus.configurator.obj.addToCart,
      hoculus.configurator.obj.dataBuyNow
    );
  },
  buy_now: function (atcSelector, parent) {
    let container = document.querySelector(parent) || null;
    if (!container) return 0;
    let dataset = container.dataset.hoculusBuyNow;
    let atc = document.querySelector(atcSelector);
    atc.innerText = dataset;

    document.addEventListener(
      "ajaxProduct:added",
      function (evt) {
        evt.stopImmediatePropagation();
        let submit = document.querySelector(
          "#CartDrawerForm button[type='submit']"
        );
        setTimeout(function () {
          atc.classList.toggle(hoculus.configurator.obj.loadingClass);
          submit.click();
        }, 0);
      },
      true
    );
  },
  updatePrice: function (variant) {
    console.log("price");
    if (hoculus.configurator.obj.init) {
      var active_currency = "$";
      switch (Shopify.currency.active) {
        case "EUR":
          active_currency = "€";
          break;
      }
      document.querySelector(
        hoculus.configurator.obj.subPriceSelector
      ).innerText = Shopify.formatMoney(
        variant.selling_plan_allocations[0].price,
        active_currency + "{{amount_with_comma_separator}}"
      );
      document.querySelector(
        hoculus.configurator.obj.subDeliverySelector
      ).innerText =
        Shopify.formatMoney(
          variant.selling_plan_allocations[0].per_delivery_price,
          active_currency + "{{amount_with_comma_separator}}"
        ) + "/box";
    }
  },
  optionSplit: class {
    constructor(data) {
      this.data = data;
      this.orInSelector =
        '.variant-input[data-index="option' + this.data.option_index + '"]';
      // this.orInSelector = 'fieldset:not(.variant-input-wrap-hoculus) .variant-input[data-index="option'+this.data.option_index+'"]';
      if(document.querySelector(this.orInSelector).parentElement.parentElement.parentElement.previousElementSibling.classList.contains('hidden-label')){
      document.querySelector(this.orInSelector).parentElement.parentElement.parentElement.previousElementSibling.classList.add('hidden')
      }
      this.container = document.querySelector(
        this.orInSelector
      ).parentElement.parentElement;
      data.checked ? (this.checked = 'checked="checked"') : (this.checked = "");
      if (
        hoculus.configurator.obj.groups.includes(this.data.group_title) ===
        false
      ) {
        this.appendContainer();
        hoculus.configurator.obj.groups.push(this.data.group_title);
      }
      if (
        hoculus.configurator.obj.hidden.includes(this.data.option_index) ===
        false
      ) {
        this.hideOriginal();
        hoculus.configurator.obj.hidden.push(this.data.option_index);
      }
      this.appendOption();
      this.initListener();
      this.setOptions();
    }
    hideOriginal() {
      let _this = this;
      this.container.style.display = "none";
    }
    appendContainer() {
      let _this = this;
      this.variantVrapper = document.createElement("div");
      this.variantVrapper.innerHTML =
        `<div class="variant-wrapper js" data-type="button" data-group-handle="` +
        _this.data.group_handle +
        `">
			  <div class="label-container">
				  <label class="variant__label">
				  	` +
        _this.data.group_title +
        `
				  </label>
				  <span></span>
			  </div>
			  <fieldset class="variant-input-wrap-hoculus"
			    name="` +
        _this.data.option_value +
        `"
			    data-index="` +
        _this.data.option_index +
        `"
			    id="Hoculus-option-split-container-fields-` +
        _this.data.option_index +
        `">
			    <legend class="hide">` +
        _this.data.option_value +
        `</legend>
			  </fieldset>
			</div>`;
      this.variantVrapper = this.variantVrapper.firstChild;
      this.container.parentElement.insertBefore(
        this.variantVrapper,
        this.container
      );
    }
    appendOption() {
      let label_content, style, badge;
      this.data.image
        ? (label_content = `<img src="` + this.data.image + `">`)
        : (label_content = this.data.option_value);
      this.data.max_width != 100
        ? (style = 'style="max-width:' + this.data.max_width + '%"')
        : (style = "");
      let _this = this;
      this.data.badge != ""
        ? (badge = `<div class="option-subtitle">` + this.data.badge + `</div>`)
        : (badge = "");
      this.variantInput = document.createElement("div");
      this.variantInput.innerHTML =
        `<div 
		        class="variant-input hoculus-split-input"
		        data-index="option` +
        _this.data.option_index +
        `"
		        data-value="` +
        _this.data.option_value +
        `" ` +
        style +
        `>
		        <input type="radio"
		          ` +
        _this.checked +
        `
		          value="` +
        _this.data.option_value +
        `"
		          name="hoculus-group-` +
        encodeURI(_this.data.group_title) +
        `"
		          id="Hoculus-option-split-` +
        _this.data.option_value.replace(/\s/g, "") +
        `-` +
        encodeURI(_this.data.group_title) +
        `"
		          data-hoculus-variant-input
		          >
		          <label
		            for="Hoculus-option-split-` +
        _this.data.option_value.replace(/\s/g, "") +
        `-` +
        encodeURI(_this.data.group_title) +
        `"
		            class="variant__button-label">
		        	` +
        label_content +
        `
		        	</label>
		        ` +
        badge +
        `
		      </div>`;
      this.variantInput = this.variantInput.firstChild;
      document
        .querySelector(
          "#Hoculus-option-split-container-fields-" + _this.data.option_index
        )
        .appendChild(this.variantInput);
    }
    initListener() {
      let _this = this;
      this.variantInput
        .querySelector("input")
        .addEventListener("change", (e) => {
          let buttonName = document.querySelector("[data-add-to-cart]");
          if (e.target.value == "one time purchase(with €10 extra cost)") {
            buttonName.innerText = "ACQUISTA ORA";
          } else {
            buttonName.innerText = "INIZIA SUBITO";
          }
          _this.setOptions();
        });
    }
    setOptions() {
      let _this = this;
      let optionsArray = [];
      let inputs = document.querySelectorAll(
        '.hoculus-split-input[data-index="option' +
          _this.data.option_index +
          '"]'
      );
      let originalInputs = document.querySelectorAll(
        'fieldset:not(.variant-input-wrap-hoculus) .variant-input[data-index="option' +
          _this.data.option_index +
          '"]'
      );
      inputs.forEach((e) => {
        let input = e.querySelector("input");
        if (input.checked === true) {
          optionsArray.push(e.dataset.value);
          if (input.value == _this.data.option_value) {
            document.querySelector(
              '[data-group-handle="' + _this.data.group_handle + '"] span'
            ).innerText = e.dataset.value;
          }
        }
      });
      originalInputs.forEach((e) => {
        let toClick = false;
        toClick = optionsArray.every((item) => e.dataset.value.includes(item));
        toClick === true ? e.querySelector("input").click() : 0;
      });
    }
  },
  multiCheck: class {
    constructor(e) {
      this.element = e;
      this.settings = JSON.parse(e.dataset.settings);
      this.initListener();
    }
    initListener() {
      let _this = this;
      this.element.querySelector("input").addEventListener("change", (e) => {
        document.querySelectorAll(
          "#Hoculus-multicheck-container-" +
            JSON.parse(e.target.parentElement.dataset.settings)
              .group_attribute +
            " input:checked"
        ).length > 0
          ? hoculus.configurator.obj.multiCheck.updateAttributes()
          : (e.target.checked = true);
      });
    }
    static updateAttributes() {
      let attributes = {};
      document
        .querySelectorAll(hoculus.configurator.obj.multiCheckSelector)
        .forEach((e) => {
          let settings = JSON.parse(e.dataset.settings);
          let input = e.querySelector('input[type="checkbox"]');
          if (input.checked) {
            if (settings.group_attribute in attributes) {
              attributes[settings.group_attribute].push(settings.option_value);
            } else {
              attributes[settings.group_attribute] = [settings.option_value];
            }
          }
        });
      let form = document.querySelector(hoculus.configurator.obj.formSelector);
      form.querySelectorAll("input[hoculus-hidden-multicheck-input]").length > 0
        ? form
            .querySelectorAll("input[hoculus-hidden-multicheck-input]")
            .forEach((e) => e.remove())
        : 0;
      for (const [key, value] of Object.entries(attributes)) {
        let input = document.createElement("div");
        input.innerHTML =
          `<input id="hoculus-hidden-multicheck-` +
          key +
          `" type="hidden" name="properties[` +
          key +
          `]" value="` +
          value.join(", ") +
          `" hoculus-hidden-multicheck-input>`;
        form.appendChild(input);
        let span = document.querySelector(
          "#Hoculus-multicheck-container-" + key + " span"
        );
        span.innerText = value.join(", ");
      }
    }
  },
  slider: class {
    constructor(e) {
      this.element = e;
      this.settings = JSON.parse(e.dataset.settings);
      this.initListener();
    }
    initListener() {
      let _this = this;
      this.element.querySelector("input").addEventListener("change", (e) => {
        hoculus.configurator.obj.slider.updateAttributes();
      });
    }
    static updateAttributes() {
      let attributes = {};
      document
        .querySelectorAll(hoculus.configurator.obj.sliderSelector)
        .forEach((e) => {
          let settings = JSON.parse(e.dataset.settings);
          let input = e.querySelector("input");
          let message = "";
          let input_value = parseInt(input.value);
          input_value > 0
            ? (message += input_value + "% " + settings.right_value)
            : 0;
          input_value > 0 && input_value < 100 ? (message += " - ") : 0;
          input_value < 100
            ? (message +=
                Math.abs(input_value - 100) + "% " + settings.left_value)
            : 0;

          if (settings.group_attribute in attributes) {
            attributes[settings.title].push(message);
          } else {
            attributes[settings.title] = [message];
          }
        });
      let form = document.querySelector(hoculus.configurator.obj.formSelector);
      form.querySelectorAll("input[hoculus-hidden-slider-input]").length > 0
        ? form
            .querySelectorAll("input[hoculus-hidden-slider-input]")
            .forEach((e) => e.remove())
        : 0;
      for (const [key, value] of Object.entries(attributes)) {
        let input = document.createElement("div");
        input.innerHTML =
          `<input id="hoculus-hidden-multicheck-` +
          key +
          `" type="hidden" name="properties[` +
          key +
          `]" value="` +
          value.join(", ") +
          `" hoculus-hidden-slider-input>`;
        form.appendChild(input);
      }
    }
  },
  radio: class {
    constructor(e) {
      this.element = e;
      this.settings = JSON.parse(e.dataset.settings);
      this.initListener();
    }
    initListener() {
      let _this = this;
      this.element.querySelector("input").addEventListener("change", (e) => {
        hoculus.configurator.obj.radio.updateAttributes();
        if (e.target.getAttribute("data_id") != "") {
          forGiftProduct(e.target);
        }
      });
    }
    static updateAttributes() {
      let attributes = {};
      // console.log(attributes);
      document
        .querySelectorAll(hoculus.configurator.obj.radioSelector)
        .forEach((e) => {
          let settings = JSON.parse(e.dataset.settings);
          let input = e.querySelector('input[type="radio"]');
          if (input.checked) {
            attributes[settings.group_attribute] = settings.option_value;
          }
        });
      let form = document.querySelector(hoculus.configurator.obj.formSelector);
      form.querySelectorAll("input[hoculus-hidden-radio-input]").length > 0
        ? form
            .querySelectorAll("input[hoculus-hidden-radio-input]")
            .forEach((e) => e.remove())
        : 0;
      for (const [key, value] of Object.entries(attributes)) {
        let input = document.createElement("div");
        input.innerHTML =
          `<input id="hoculus-hidden-radio-` +
          key +
          `" type="hidden" name="properties[` +
          key +
          `]" value="` +
          value +
          `" hoculus-hidden-radio-input>`;
        form.appendChild(input);
      }
    }
  },
  optionSubtitle: class {
    constructor(data) {
      this.data = data;
      this.container = document.querySelector(
        'fieldset[data-index="option' + this.data.option_index + '"]'
      ).parentNode;
      this.subtitle = document.createElement("div");
      this.subtitle.innerHTML =
        `<span class="subtitle">` + this.data.subtitle + `</span>`;
      this.subtitle = this.subtitle.firstChild;
      this.container
        .querySelector("label.variant__label")
        .appendChild(this.subtitle);
    }
  },
  special__note: class {
    constructor(e) {
      this.initListener(e);
    }
    initListener(ele) {
      ele.addEventListener("input", (ele) => {
        hoculus.configurator.obj.special__note.updateAttributes(
          ele.target.name,
          ele.target.dataset.settings,
          ele.target.value
        );
      });
    }
    static updateAttributes(name, ele, value) {
      let form = document.querySelector(hoculus.configurator.obj.formSelector);
      form.querySelectorAll("input[hoculus-hidden-" + ele + "-input]").length >
      0
        ? form
            .querySelectorAll("input[hoculus-hidden-" + ele + "-input]")
            .forEach((e) => e.remove())
        : 0;
      let input = document.createElement("div");
      input.innerHTML =
        `<input id="hoculus-hidden-` +
        ele +
        `" type="hidden" name="properties[` +
        name +
        `]" value="` +
        value +
        `" hoculus-hidden-${ele}-input>`;
      form.appendChild(input);
    }
  },
};
hoculus.utils.domready(hoculus.utils.onLoad);

// for gift product

function forGiftProduct(field) {
  var questionName = field.getAttribute("name");
  field = field.getAttribute("data_field");
  // Create the array dynamically
  // if (document.querySelector(`textarea[name="` + field + `"]`) != null) {
  //   console.log(document.querySelector(`textarea[name="` + field + `"]`));
  //   document.querySelector(`textarea[name="` + field + `"]`).style.display =
  //     "none";
  // }
  if (window[questionName] == undefined) {
    const dynamicArray = [];
    window[questionName] = dynamicArray;
  }
  let form = document.querySelector(hoculus.configurator.obj.formSelector);

  var multicheck_input_wrap = document.querySelectorAll(
    `[question_name="` + questionName + `"]`
  );
  var allMulticheck = document.querySelectorAll(
    "[hoculus-hidden-multicheck-input]"
  );
  field = field.split(",");
  multicheck_input_wrap.forEach((multiCheck) => {
    multiCheck.style = "display:flex";
    window[questionName].push(
      document.querySelector(
        `input[name="properties[` + multiCheck.getAttribute("name_attr") + `]"]`
      )
    );
  });
  var filtered = window[questionName].filter(function (el) {
    return el != null;
  });
  var allHeading = document.querySelectorAll(
    `h3[question_name="` + questionName + `"]`
  );
  allHeading.forEach((item, index) => {
    item.style.display = "block";
    console.log(item);
  });
  customObj[questionName] = filtered;
  eleStatus(customObj, questionName, field, form);
}
function eleStatus(dynamicObj, questionName, field, form) {
  arr = dynamicObj[questionName];
  arr.forEach((item) => {
    if (item != null) {
      form.appendChild(item);
    }
  });

  field.forEach((arrItem) => {
    arrItem = arrItem.trim();
    if (document.querySelector(`div[name_attr="` + arrItem + `"]`) != null) {
      document.querySelector(`div[name_attr="` + arrItem + `"]`).style =
        "display:none";
    }
    if (
      document.querySelector(`input[name="properties[` + arrItem + `]"]`) !=
      null
    ) {
      document
        .querySelector(`input[name="properties[` + arrItem + `]"]`)
        .remove();
    }

    if (document.querySelector(`h3[name_attr="` + arrItem + `"]`) != null) {
      document.querySelector(`h3[name_attr="` + arrItem + `"]`).style.display =
        "none";
    }
  });
}
